import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, InputNumber } from "antd";
import { __ } from "../../../../../../utils/i18n.js";
const LicenseAllocationField = ({ name, label, variant, free, total, disabled })=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: `rc-account-v2-license-alloc-field rc-account-v2-license-alloc-field--${variant}`,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "rc-account-v2-license-alloc-field__head",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "rc-account-v2-license-alloc-field__swatch",
                        "aria-hidden": true
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "rc-account-v2-license-alloc-field__label",
                        children: label
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Form.Item, {
                name: name,
                rules: [
                    {
                        required: true,
                        type: "number",
                        min: 0,
                        message: __("Please input a valid number.")
                    },
                    {
                        type: "number",
                        max: free,
                        message: __("Only %s left in your plan.", free)
                    }
                ],
                extra: __("%s of %s still free in your plan", free, total),
                style: {
                    marginBottom: 0
                },
                children: /*#__PURE__*/ _jsx(InputNumber, {
                    min: 0,
                    max: 1000,
                    precision: 0,
                    parser: (value)=>Number((value ?? "").toString().replace(/[^\d]/g, "") || 0),
                    disabled: disabled,
                    style: {
                        width: "100%"
                    }
                })
            })
        ]
    });
};
export { LicenseAllocationField };
